/*
 *
 * Furniture reducer
 *
 */

import { ActionType } from 'typesafe-actions';
import ActionTypes from 'containers/Configurator/constants/furniture';
import * as actions from 'containers/Configurator/actions/furniture';
import { FurnitureState } from './../types';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import cloneDeep from 'lodash/cloneDeep';

type CabinetActions = ActionType<typeof actions>;

export const initialState: FurnitureState = {
  furniture: null,
  selectedId: null,
  loading: false,
  preview: false,
  image: null,
  images: new Map(),
};

function reducer(
  state: FurnitureState = initialState,
  action: CabinetActions,
): FurnitureState {
  switch (action.type) {
    case ActionTypes.FURNITURE_LOAD_REQUEST:
      return { ...state, loading: true };
    case ActionTypes.FURNITURE_ADD_CABINET:
      if (state.furniture) {
        const newFurniture = state.furniture
          .clone()
          .add(action.payload.cabinet);
        return {
          ...state,
          furniture: newFurniture,
          selectedId: null,
        };
      } else {
        const furniture = new Furniture();
        return {
          ...state,
          furniture: furniture.add(action.payload.cabinet),
          selectedId: action.payload.cabinet.id,
        };
      }
    case ActionTypes.FURNITURE_SET_IMAGE:
      const images = state.images;
      if (action.payload.cabinetId) {
        images.set(action.payload.cabinetId, action.payload.image);
        return {
          ...state,
          images: cloneDeep(images),
        };
      }
      return {
        ...state,
        image: action.payload.image,
      };
    case ActionTypes.FURNITURE_SELECT_CABINET:
      if (state.furniture) {
        return {
          ...state,
          selectedId: action.payload.id,
        };
      }
      return state;
    case ActionTypes.FURNITURE_SELECT_FROMID_CABINET:
      if (state.furniture) {
        return {
          ...state,
          selectedId: action.payload.id,
        };
      }
      return state;
    case ActionTypes.FURNITURE_LOAD_SUCCESS:
      const furniture = action.payload.furniture;
      if (furniture.quantity === 1 && furniture.first) {
        return {
          ...state,
          furniture: furniture,
          selectedId: furniture.first.id,
          loading: false,
        };
      }
      return {
        ...state,
        furniture: furniture,
        selectedId: null,
        loading: false,
      };
    case ActionTypes.CABINET_LOAD_SUCCESS:
      return {
        ...state,
        furniture: new Furniture([
          { order: 0, cabinet: action.payload.cabinet },
        ]),
        selectedId: action.payload.cabinet.id,
        loading: false,
      };
    case ActionTypes.CABINET_LOAD_FAILURE:
      return { ...state, loading: false };
    case ActionTypes.CABINET_RESTORE:
      if (state.furniture) {
        const furniture = state.furniture.clone();
        if (state.selectedId !== null) {
          return {
            ...state,
            furniture: furniture.replace(
              action.payload.cabinet,
              state.selectedId,
            ),
            preview: false,
          };
        }
        return state;
      }
      return state;
    case ActionTypes.FURNITURE_RESTORE_STEP:
      return {
        ...state,
        furniture: action.payload.step.furniture,
        selectedId: action.payload.step.selectedId,
      };
    case ActionTypes.CABINET_UPDATE_SUCCESS:
      if (state.furniture) {
        // Save locally
        if (!action.payload.preview) {
          localStorage.setItem(
            'furniture',
            JSON.stringify(action.payload.furniture, Furniture.replacer),
          );
        }

        return {
          ...state,
          furniture: action.payload.furniture,
          selectedId: action.payload.selectedId,
          preview: action.payload.preview,
        };
      }
      return state;
    case ActionTypes.SELECT_FURNITURE:
      return { ...state, selectedId: null };
    case ActionTypes.FURNITURE_REORDERING:
      if (state.furniture) {
        return {
          ...state,
          furniture: state.furniture
            .clone()
            .reorder(action.payload.source, action.payload.destination),
        };
      }
      return state;
    case ActionTypes.FURNITURE_RENAME:
      const furniture2 = state.furniture?.clone();
      if (furniture2) {
        furniture2.name = action.payload.name;
        return {
          ...state,
          furniture: furniture2,
        };
      }
      return state;

    default:
      return state;
  }
}

export default reducer;
